import React, { useMemo } from 'react';
import OrganizationAnalyticsLineChart from './OrganizationAnalyticsLineChart';
import { formatTimeCategoriesByRange, getDurationWithMessagesTooltipFormatter, mapIdsToLabels } from './chartUtils';

const OrganizationChatterAverageResponseTimeByTimeChart = ({ data, chatterLabelMap, dateRange, pending }) => {
  const { categories, series, tooltipFormatter } = useMemo(
    () => ({
      categories: formatTimeCategoriesByRange(data?.time || [], dateRange),
      series: (data?.series || []).map(item => ({
        name: mapIdsToLabels([item.chatterId], chatterLabelMap)[0],
        data: item.averageResponseTimeSeconds || [],
        messages: item.messages || [],
      })),
      tooltipFormatter: getDurationWithMessagesTooltipFormatter(),
    }),
    [data, chatterLabelMap, dateRange],
  );

  return (
    <OrganizationAnalyticsLineChart
      title="Average Response Time Over Time"
      subtitle="Response time trend for the selected chatters."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select one or more chatters to load response time over time."
      valueType="duration"
      tooltipFormatter={tooltipFormatter}
    />
  );
};

export default OrganizationChatterAverageResponseTimeByTimeChart;
